<template>
  <div id="api_out" class="tab-pane">
    <LogFilterBox @apply="search" @clear="clearSearch">
      <div class="form-row align-items-end">
        <div class="col-12 col-md-6">
          <label class="form-label">{{ trans("examination.case_no") }}</label>
          <input
            v-model.trim="caseNumber"
            type="text"
            class="form-control"
            autocomplete="off"
            :placeholder="trans('forms.searchForCaseNumber')"
          />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">Request URL</label>
          <input
            v-model.trim="request"
            type="text"
            class="form-control"
            autocomplete="off"
            :placeholder="trans('forms.searchForRequestUrl')"
          />
        </div>
      </div>
    </LogFilterBox>

    <clip-loader v-if="loading" />

    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="sortable-table-header">
          <tr>
            <th>Request url</th>
            <th>User</th>
            <th>Body</th>
            <th>Examination</th>
            <th>Response code</th>
            <th>Created at</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, index) in api_out.logs" :key="index">
            <td>{{ log.request_uri }}</td>
            <td>{{ log.user }}</td>
            <td><ApiOutBody :text="log.text" /></td>
            <td>{{ log.examination }}</td>
            <td>{{ log.response_code }}</td>
            <td>{{ log.created_at }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row-fluid float-right">
      <DerPaginate
        v-model="api_out.paginate.current_page"
        :page-count="api_out.paginate.last_page"
        :show-go="true"
        @change="getApiOutResults"
      />
    </div>
  </div>
</template>

<script>
import DerPaginate from "../../../design-system/DerPaginate.vue";
import ApiOutBody from "./ApiOutBody.vue";
import LogFilterBox from "./LogFilterBox.vue";

export default {
  components: { DerPaginate, ApiOutBody, LogFilterBox },
  data() {
    return {
      loading: true,
      api_out: {
        paginate: {
          current_page: 0,
          total: 0,
          last_page: 0,
        },
        logs: [],
      },
      caseNumber: "",
      request: "",
    };
  },
  created: function () {
    this.getApiOutResults();
  },
  methods: {
    getApiOutResults(page) {
      this.loading = true;
      if (typeof page === "undefined") {
        page = 1;
      }
      axios
        .get("/api/internal/admin/logs/api-out?page=" + page)
        .then((data) => {
          var collection = data.data;
          this.api_out.paginate = collection.paginate;
          this.api_out.logs = collection.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.userErrorMessage(error);
        });
    },
    search: function () {
      this.loading = true;
      axios
        .get(
          "/api/internal/admin/logs/api-out?case_number=" +
            this.caseNumber +
            "&request=" +
            this.request,
        )
        .then((data) => {
          var collection = data.data;
          this.api_out.logs = collection.data;
          this.api_out.paginate = collection.paginate;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.userErrorMessage(error);
        });
    },
    clearSearch: function () {
      this.caseNumber = "";
      this.request = "";
      this.getApiOutResults();
    },
  },
};
</script>
